<div class="animate-fadeIn fixed top-0 left-0 z-50 flex h-full w-full items-center justify-center">
    <div class="absolute top-3 right-3 z-15 md:top-6 md:right-6">
        <p-button icon="pi pi-times" severity="secondary" (click)="helpService.closeHelp()" size="large" />
    </div>

    <div class="relative z-10 flex h-[90vh] flex-col items-center overflow-y-auto p-2 px-10">
        <div class="mb-4 text-center md:mb-8">
            <h1 class="mb-2 text-2xl font-semibold text-gray-900 md:text-3xl">What can I help you with?</h1>
            <p class="text-base text-gray-500 md:text-lg">Here are some things I can assist you with</p>
        </div>

        <div class="grid w-full max-w-5xl grid-cols-1 gap-4 py-2 md:grid-cols-2 lg:grid-cols-3">
            @for (useCase of useCases(); track useCase.id) {
                <app-use-case-card [useCase]="useCase" />
            }
        </div>
    </div>
</div>

<div class="fixed top-0 left-0 z-5 h-full w-full bg-white/50 backdrop-blur-sm"></div>
